export default __webpack_public_path__ + "static/media/typemaster.a31ba959.svg";